import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { isEmpty } from 'lodash-es';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const setObj: Record<string, unknown> = {};
        const headers: Record<string, string> = {};

        // skip to set content-type for multipart/form-data request
        if ((request.body instanceof FormData) === false
            && !request.headers.has('content-type')) {
            headers['Content-Type'] = 'application/json';
        } 
        
        if (!request.withCredentials && request.url.startsWith('/')) {
            setObj.withCredentials = true;
        }

        if (!isEmpty(headers)) {
            setObj.setHeaders = headers;
        }
        if (!isEmpty(setObj)) {
            return next.handle(request.clone(setObj));
        }
        
        return next.handle(request);
    }
}
